var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m204 269.942h171.282v139.796h-171.282z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.328 18.734c0-10.33-8.404-18.734-18.734-18.734s-18.735 8.404-18.735 18.734v459.531h37.469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.938 71.203h71.203l-71.203-71.203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.938 101.203v-101.203h-277.354c2.411 5.771 3.744 12.1 3.744 18.734v493.266h374.812v-410.797zm-237.522-63.548h202.066v30h-202.066zm0 67.469h202.066v30h-202.066zm302.291 164.818h-35.425v139.796h35.425v30h-35.425v35.332h-30v-35.332h-171.282v35.332h-30v-35.332h-35.238v-30h35.238v-139.796h-35.238v-30h35.238v-35.332h30v35.332h171.282v-35.332h30v35.332h35.425z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpose);
export default __webpack_public_path__ + "static/media/purpose.5531af372e53726304b94f324f30c3e8.svg";
export { ForwardRef as ReactComponent };